// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"fbc32895","124":"03bef8ad","425":"7d37839b","532":"557b5bc7","787":"c0ac620b"}[chunkId] + ".chunk.js";
};